import DatahubContext from '@react/data-hub/context/datahubContext';
import { useContext } from 'react';

export const useDatahub = () => useContext(DatahubContext);
